import { createCurrentHOC } from '@beef/redux';
import { emptyArr, emptyObj } from '@beef/utils';
import { createSelector } from 'reselect';
import { getFTTB, getFTTBIsActive } from './commonSelectors';
import { SERVICE_CONNECTION_CODES } from '../../constants';
import { EMAIL_REGEXP } from '../../../../constants/common';

export const getFTTBAdditionalServices = (state) => getFTTB(state).additionalServices || emptyArr;
export const getFTTBExtraServices = (state) => getFTTB(state).extraServices || emptyArr;

export const [
  getCurrentService = emptyObj,
  withFTTBServiceMapper,
] = createCurrentHOC(getFTTBAdditionalServices, (item) => item.serviceId);

export const getFTTBServiceAdditionalInformation = (state) => getCurrentService(state).additionalInformation;
export const getFTTBServicePresetUrl = (state) => getCurrentService(state).presetUrl;
export const getFTTBServicePrice = (state) => getCurrentService(state).price;
export const getFTTBServiceTitle = (state) => getCurrentService(state).title;
export const getFTTBServiceId = (state) => getCurrentService(state).serviceId;
export const getFTTBServiceShortDescription = (state) => getCurrentService(state).shortDescription;
export const getFTTBServiceAntivirusInfo = (state) => getCurrentService(state).antivirusAdditionalInformation || emptyObj;
export const getFTTBServiceSplId = (state) => getCurrentService(state).splId;
export const getFTTBServiceIsBlocked = (state) => !!getCurrentService(state).isBlocked;
export const getFTTBServiceIsEnabled = (state) => !!getCurrentService(state).isEnabled;
export const getFTTBServiceError = (state) => getCurrentService(state).error || emptyObj;
export const getFTTBServiceDisconnectionParams = (state) => getCurrentService(state).disconnectionParams || emptyObj;
export const getFTTBServiceIsDisconnectionDialogVisible = (state) => getCurrentService(state).isDisconnectDialogVisible;

// service extra state
export const getFTTBServiceIsDisabled = createSelector(getFTTBIsActive, getCurrentService, (isActive, { isDisabled }) => !isActive || isDisabled);
export const getFTTBServiceIsLoading = (state) => getCurrentService(state).isLoading;
export const getFTTBServiceIsDisconnection = (state) => getCurrentService(state).isDisconnecting;
export const getFTTBServiceIsChecked = (state) => getCurrentService(state).isChecked;

export const getFTTBServiceConnectionDate = (state) => getCurrentService(state).connectionDate;
export const getFTTBServiceDisconnectionDate = (state) => getCurrentService(state).disconnectionDate;
export const getFTTBServiceRequestDisconnectionDate = (state) => getCurrentService(state).requestDisconnectionDate;
export const getFTTBServiceRequestId = (state) => getCurrentService(state).requestId;
export const getFTTBServiceFutureRequestId = (state) => getCurrentService(state).futureRequestId;
export const getFTTBServiceDisconnectRequestId = (state) => getCurrentService(state).disconnectRequestId;
export const getFTTBServiceMultiConvergenceAdditionalInformation = (state) => getCurrentService(state).multiconvergenceAdditionalInformation || emptyObj;

export const getFTTBAdditionalPopup = (state) => getFTTB(state).additionalPopup || emptyObj;
export const getFTTBServiceIsConnectionRequestPending = (state) => !getFTTBServiceIsEnabled(state) && getFTTBServiceConnectionDate(state);
export const getFTTBServiceIsDisconnectionRequestPending = (state) => getFTTBServiceIsEnabled(state) && getFTTBServiceDisconnectionDate(state);
export const getAdditionalServicePopupIsConnection = (state) => getFTTBAdditionalPopup(state).type === SERVICE_CONNECTION_CODES.CONNECTING;
export const getAdditionalServicePopupIsError = (state) => getFTTBAdditionalPopup(state).type === SERVICE_CONNECTION_CODES.ERROR;
export const getAdditionalServicePopupIsNoMoney = (state) => getFTTBAdditionalPopup(state).type === SERVICE_CONNECTION_CODES.NO_MONEY;
export const getAdditionalServicePopupIsSuccess = (state) => getFTTBAdditionalPopup(state).type === SERVICE_CONNECTION_CODES.SUCCESED;
export const getAdditionalServicePopupIsPromised = (state) => getFTTBAdditionalPopup(state).type === SERVICE_CONNECTION_CODES.PROMISED;
export const getAdditionalServicePopupIsLoading = (state) => getFTTBAdditionalPopup(state).type === SERVICE_CONNECTION_CODES.LOADING;
export const getFTTBAdditionalPopupConnection = (state) => getFTTBAdditionalPopup(state).connecting || emptyObj;
export const getFTTBAdditionalPopupSuccesed = (state) => getFTTBAdditionalPopup(state).succesed || emptyObj;
export const getFTTBAdditionalPopupNoMoney = (state) => getFTTBAdditionalPopup(state).noMoney || emptyObj;
export const getFTTBAdditionalPopupError = (state) => getFTTBAdditionalPopup(state).error || emptyObj;
export const getFTTBAdditionalPopupPromised = (state) => getFTTBAdditionalPopup(state).promised || emptyObj;
export const getFTTBAdditionalPopupIsOpen = (state) => getFTTBAdditionalPopup(state).isOpen;
export const getFTTBAdditionalPopupConnectionDataService = (state) => getFTTBAdditionalPopupConnection(state).service || emptyObj;

export const getIsNeedEmailNotEmpty = createSelector(
  getFTTBAdditionalPopupConnection,
  (data) => !data?.needEmail || data?.email?.match(EMAIL_REGEXP),
);
